import type { SvgPathProps } from '../Icon';

const XmlFile: React.FC<SvgPathProps> = ({ isHovered }: SvgPathProps): React.JSX.Element => {
  const normal = (
    <path
      fillRule="evenodd"
      d="M12 39.1h23.999V8.9H12v30.2zm-1.301 1.3H37.3V7.6H10.699v32.8zm7.482-7.089l1.037-1.796 1.042 1.796h.955L19.692 30.9l1.467-2.37h-.943l-1.011 1.766-.999-1.766h-.934l1.468 2.37-1.501 2.411h.942zm4.083-10.476l-2.292-2.292 2.292-2.292-.707-.707-2.999 2.999 2.999 2.999.707-.707zm6.3 5.695h-.797v4.781h2.994v-.637h-2.197V28.53zm-2.12-4.988l2.998-2.999-2.998-2.999-.707.707 2.291 2.292-2.291 2.292.707.707zm-4.57 9.769h.798v-1.629l-.082-2.092h.011l1.425 3.721h.535l1.431-3.73h.011l-.083 2.101v1.629h.798V28.53h-1.034l-1.39 3.703-1.385-3.703h-1.035v4.781z"
    />
  );

  const normalHover = (
    <path
      fillRule="evenodd"
      d="M12.001 39.1H36V8.9H12.001v30.2zM10.7 40.4h26.601V7.6H10.7v32.8zm7.48-7.089l1.038-1.796 1.042 1.796h.955L19.692 30.9l1.468-2.37h-.944l-1.01 1.766-.999-1.766h-.935l1.468 2.37-1.501 2.411h.941zm3.084-10.476l-2.292-2.292 2.292-2.292-.707-.707-2.999 2.999 2.999 2.999.707-.707zm7.3 5.695h-.798v4.781h2.995v-.637h-2.197V28.53zm-1.12-4.988l2.998-2.999-2.998-2.999-.707.707 2.291 2.292-2.291 2.292.707.707zm-5.569 9.769h.797v-1.629l-.082-2.092h.011l1.425 3.721h.535l1.432-3.73h.009l-.082 2.101v1.629h.798V28.53h-1.034l-1.39 3.703-1.385-3.703h-1.034v4.781z"
    />
  );

  return isHovered ? normalHover : normal;
};

export default XmlFile;
